<script>
import RelativeTime from '../RelativeTime/RelativeTime.vue';
import { mapGetters } from 'vuex';
// + Implicit dependency on ./state/NextToPlay.js
// + Implicit dependency on plugins/vue-moment.js

export default {
  components: {
    RelativeTime,
  },
  props: {
    eventId: {
      type: Number,
      default: undefined,
    },
  },
  computed: {
    ...mapGetters({
      nextToPlay: 'NextToPlay/getData',
    }),
  },
  created() {
    if (this.eventId !== undefined) {
      this.$store.dispatch('NextToPlay/fetchRelatedEvents', this.eventId);
    } else {
      this.$store.dispatch('NextToPlay/fetchNextToPlay');
    }
  },
};
</script>

<template>
  <div class="next-to-play-wide component-wrap component-wrap--scroll">
    <!-- Header -->
    <div class="next-to-play-wide__header">
      <h3 class="next-to-play-wide__header-title component-title">{{ nextToPlay.componentTitle }}</h3>
    </div>

    <!-- Main -->
    <div v-if="nextToPlay.sports" class="next-to-play-wide__main">
      <ul class="event-lists">
        <li v-for="event in nextToPlay.sports.events" :key="event.eventURL" class="event-lists__item">
          <a :href="event.eventURL" class="event-lists__link">
            <div class="event-link__header">
              <div class="event-link__header__primary">
                <span class="header__sport-icon" v-html="event.sportIcon"></span>
                <span class="header__location">{{ event.location }}</span>
              </div>
              <RelativeTime :target-time="event.startTime" class="next-to-play__time-stamp"/>
            </div>
            <div class="event-link__main">
              <div class="event-link__title">{{ event.eventTitle }}</div>
              <div class="event-link__status">
                <span>{{ event.startTime | moment('hh:mm a DD/MM/YY') }} </span>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
